import { useEffect, useState } from 'react'
import { MenuComponent } from '../../../_metronic/assets/ts/components'
import { KTIcon } from '../../../_metronic/helpers'


  const transactionType = [
    {
      key: 'transaction_type',
      value: 'topup',
      entry_type: 'cr'
    },
    {
      key: 'transaction_type',
      value: 'admin topup',
      entry_type: 'cr'
    },
    {
      key: 'consumption_type',
      value: 'booking',
      entry_type: 'dr'
    },
    {
      key: 'transaction_type',
      value: 'booking refund',
      entry_type: 'cr'
    },
    {
      key: 'consumption_type',
      value: 'arrear',
      entry_type: 'dr'
    },
    {
      key: 'transaction_type',
      value: 'recovery',
      entry_type: 'cr'
    },
    
    {
      key: 'transaction_type',
      value: 'reward',
      entry_type: 'cr'
    },
    {
      key: 'transaction_type',
      value: 'club cash',
      entry_type: 'cr'
    },
    {
      key: 'consumption_type',
      value: 'club cash revert',
      entry_type: 'dr'
    },
    {
      key: 'consumption_type',
      value: 'admin reverted',
      entry_type: 'dr'
    },
  ]


const Filter = ({ filter, setFilter, getTransactionType, getConsumptionType }) => {
  const [status, setStatus] = useState('');

  useEffect(() => {
    MenuComponent.reinitialization()
  }, [])

  const resetData = () => {
    setStatus('')
    setFilter({})
  }

  const filterData = () => {
   setFilter(transactionType.find(item => item.value === status))
  }

  return (
    <>
      <button
        type='button'
        className='btn me-3'
        data-kt-menu-trigger='click'
        data-kt-menu-placement='bottom-end'
        style={{ backgroundColor: '#ffa459', color: 'white' }}
      >
        <KTIcon iconName='filter' className='fs-2 text-white' iconType={filter?.key ? 'solid' : 'duotone'} />
        Filter
      </button>
      <div className='menu menu-sub menu-sub-dropdown w-300px w-md-325px' data-kt-menu='true'>
        <div className='px-7 py-5'>
          <div className='fs-5 text-dark fw-bolder'>Filter By Transaction Type</div>
        </div>
        <div className='separator border-gray-200'></div>
        <div className='px-7 py-5' data-kt-user-table-filter='form'>
          <div className='mb-5'>
            <select
              className='form-select form-select-solid fw-bolder'
              data-kt-select2='true'
              data-placeholder='Select Status'
              data-allow-clear='true'
              data-kt-user-table-filter='two-step'
              data-hide-search='true'
              onChange={(e) => {
                setStatus(e.target.value)
              }}
              value={status}
            >
              <option value="" selected>Select Transaction Type</option>
              {transactionType.map((item, index) => (
                <option key={index} value={item.value}>{item.key === 'transaction_type' ? getTransactionType(item.value) : getConsumptionType(item.value)}</option>
              ))}
            </select>
          </div>
          <div className='d-flex justify-content-end'>
            <button
              type='button'
              onClick={resetData}
              className='btn btn-light btn-active-light-primary fw-bold me-2 px-6'
            >
              Reset
            </button>
            <button
              disabled={!status}
              type='button'
              onClick={filterData}
              className='btn fw-bold px-6'
              data-kt-menu-dismiss='true'
              data-kt-user-table-filter='filter'
              style={{ backgroundColor: '#ffa459', color: '#fff' }}
            >
              Apply
            </button>
          </div>
        </div>
      </div>
    </>
  )
}

export { Filter }
